export default __webpack_public_path__ + "assets/images/bccb9649384cf55cdee8609f8a9c1667.png";